import React from 'react';
import BeneficiaryCategories from './BeneficiaryCategories';
import MainCategory from './MainCategory';
import BeneficiaryLoadError from './BeneficiaryLoadError';
import {
  Beneficiaries,
  BeneficiaryQuery,
  BeneficiaryTitleInfoProps,
} from './utils/beneficiaryInterfaces';
import TrueImpactLoading from 'shared/components/TrueImpactLoading';
import { GuidanceTextResponse } from '../utils';

export type BeneficiaryRouteType = 'landing' | 'categories';

interface BeneficiaryRoutesProps extends BeneficiaryTitleInfoProps {
  isMiniReportBuilder?: boolean;
  route: BeneficiaryRouteType;
  guidanceText: GuidanceTextResponse | undefined;
  loading: BeneficiaryQuery['loading'];
  error: BeneficiaryQuery['error'];
  beneficiaries: Beneficiaries;
  beneficiary?: string;
  allAnswers: { [id: number]: string | undefined };
  setBeneficiaries: React.Dispatch<React.SetStateAction<Beneficiaries>>;
  refetch: () => unknown;
  goBack: () => unknown;
}

export const BeneficiaryRoutes: React.FC<BeneficiaryRoutesProps> = ({
  allAnswers,
  guidanceText,
  isMiniReportBuilder,
  route,
  error,
  loading,
  beneficiaries,
  beneficiary,
  programName,
  setBeneficiaries,
  refetch,
  goBack,
}) => {
  if (loading) {
    return <TrueImpactLoading />;
  }
  if (error) {
    return <BeneficiaryLoadError refetch={refetch} />;
  }
  switch (route) {
    case 'landing':
      return (
        <MainCategory
          guidanceText={guidanceText}
          isMiniReportBuilder={isMiniReportBuilder}
          beneficiaries={beneficiaries}
          setBeneficiaries={setBeneficiaries}
          goBack={goBack}
        />
      );

    case 'categories':
      return (
        <BeneficiaryCategories
          guidanceText={guidanceText}
          allAnswers={allAnswers}
          isMiniReportBuilder={isMiniReportBuilder}
          beneficiaries={beneficiaries}
          beneficiary={beneficiary}
          setBeneficiaries={setBeneficiaries}
          programName={programName}
          goBack={goBack}
        />
      );
  }
};
